import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  // Check if JWT token AND admin role exist in localStorage
  const token = localStorage.getItem('jwt');
  const role = localStorage.getItem('role');

  if (!token || role !== 'admin') {
    // Redirect to admin login if no token or not admin
    return <Navigate to="/admin/login" replace />;
  }

  // Token exists and user is admin, allow access
  return element;
};

export default ProtectedRoute;
